import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { FONT_FAMILY } from 'common/sharedFunctions';

// Notificacion tipo "toast" para todo el panel. Mantiene la misma API que el
// AlertDialog anterior (open, onClose, children) para no tener que tocar las
// ~20 vistas que ya lo usan; solo cambia la presentacion: ahora aparece arriba
// a la derecha, con color segun el tipo de mensaje y se cierra solo.
const ERROR_HINTS = [
  'error', 'fail', 'failed', 'wrong', 'invalid', 'inváli', 'invali',
  'no se', 'not ', 'denied', 'denegad', 'incorrect', 'incorrect',
  'problema', 'no pud', 'no está', 'requerid', 'obligator', 'permiso',
];

const inferSeverity = (children) => {
  try {
    const text = (typeof children === 'string' ? children : '').toLowerCase();
    if (!text) return 'info';
    return ERROR_HINTS.some((h) => text.indexOf(h) !== -1) ? 'error' : 'success';
  } catch (e) {
    return 'info';
  }
};

export default function AlertDialog(props) {
  const { open, onClose, children, severity } = props;
  const sev = severity || inferSeverity(children);

  return (
    <Snackbar
      open={!!open}
      autoHideDuration={4500}
      onClose={(e, reason) => { if (reason === 'clickaway') return; if (onClose) onClose(); }}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <MuiAlert
        onClose={() => { if (onClose) onClose(); }}
        severity={sev}
        variant="filled"
        elevation={6}
        sx={{ fontFamily: FONT_FAMILY, alignItems: 'center', maxWidth: 420, borderRadius: '12px' }}
      >
        {children}
      </MuiAlert>
    </Snackbar>
  );
}
